
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.751 15h-16.5a.75.75 0 00-.75.75v1.15c0 2.088-.487 4.147-1.42 6.015A.75.75 0 00.75 24h19.5a.75.75 0 00.67-1.085 13.462 13.462 0 01-1.42-6.015v-1.15a.75.75 0 00-.75-.75zm-.75 1.5v.4l.007.464a14.965 14.965 0 001.01 4.952l.074.184H1.909l.075-.184A14.963 14.963 0 003.001 16.9L3 16.5h15.001z"}}),_c('path',{attrs:{"d":"M10.72.006L10.502 0a3.75 3.75 0 00-3.75 3.75c0 1.325.112 2.648.335 3.954l.119.64A.539.539 0 016.679 9H3.75a3.75 3.75 0 00-3.75 3.751V15a1.5 1.5 0 001.5 1.5h18a1.5 1.5 0 001.5-1.5v-2.25A3.75 3.75 0 0017.251 9h-2.927a.539.539 0 01-.537-.585l.015-.101c.253-1.258.402-2.577.44-3.902l.009-.651c0-2-1.553-3.64-3.53-3.755zM10.502 1.5l.155.005c1.163.068 2.095 1.052 2.095 2.245l-.009.63a22.015 22.015 0 01-.418 3.681l-.027.184a2.06 2.06 0 00.45 1.509 2.04 2.04 0 001.577.746h2.927a2.25 2.25 0 012.25 2.25V15h-18v-2.25a2.25 2.25 0 012.25-2.25h2.927a2.04 2.04 0 002-2.44l-.115-.62a22.001 22.001 0 01-.312-3.69 2.25 2.25 0 012.25-2.25zM15.751 18.75a.75.75 0 01.743.648l.007.102v3.75a.75.75 0 01-1.493.102L15 23.25V19.5a.75.75 0 01.75-.75zM12.751 19.5a.75.75 0 01.743.648l.007.102v3a.75.75 0 01-1.493.102L12 23.25v-3a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    